import React, { useEffect, useRef, useState } from 'react'
import '../../Styles/Accordian.css';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Repository from '../../Repository/Repository';
import { Link } from 'react-router-dom';
function Accordian() {
    const [articles, setArticles] = useState(Repository)
    //const categoryA = articles.filter(function(el) {return el.category == "a"})
    //const categoryB = articles.filter(function(el) {return el.category == "b"})
    const storedArticle = JSON.parse(localStorage.getItem('storedArticles') || '[]');
    const tech = storedArticle.filter(el => el.category?.toLowerCase() === "tech");
    const countries = storedArticle.filter(el => el.category?.toLowerCase() === "countries");
    const business = storedArticle.filter(el => el.category?.toLowerCase() === "business");
    const travel = storedArticle.filter(el => el.category?.toLowerCase() === "travel");
    const art = storedArticle.filter(el => el.category?.toLowerCase() === "art");
    const geopolitics = storedArticle.filter(el => el.category?.toLowerCase() === "geo-politics");
    const social = storedArticle.filter(el => el.category?.toLowerCase() === "social");
    const infrastructure = storedArticle.filter(el => el.category?.toLowerCase() === "infrastructure");
    const startups = storedArticle.filter(el => el.category?.toLowerCase() === "startups");

    const [data, setData] = useState([
        //{category:"A", pages:categoryA},
        //{category:"B", pages:categoryB},
        {category:"business", pages:business},
        {category:"travel", pages:travel},
        {category:"tech", pages:tech},
        {category:"countries", pages:countries},
        {category:"art", pages:art},
        {category:"geopolitics", pages:geopolitics},
        {category:"social", pages:social},
        {category:"infrastructure", pages:infrastructure},
        {category:"startups", pages:startups},

        ])
        
    //console.log("categoryA",categoryA)
        
    
    const [openDropdowns, setOpenDropdowns] = useState([]);
    const subItemsRefs = useRef({}); // Store references to sub-item elements
    const plusButton = "https://img.icons8.com/ios/50/plus-2-math.png";
    const minusButton = "https://img.icons8.com/ios/50/minus-2-math.png";


    const toggleDropdown = (id, event) => {
        event.preventDefault();
        //console.log(id)
        setOpenDropdowns((prevOpenDropdowns) =>
            prevOpenDropdowns.includes(id)
              ? prevOpenDropdowns.filter((dropdownId) => dropdownId !== id) // Remove the dropdown if already open
              : [...prevOpenDropdowns, id] // Add the dropdown if not open
          );
    }

    function buttonToRender(id) {
        if (openDropdowns.includes(id)) {
            return (minusButton)
        } else {
            return (plusButton)
        }
    }
    useEffect(()=> {
        openDropdowns.forEach((id) => {
            if (subItemsRefs.current[id]) {
              subItemsRefs.current[id].classList.add('open');
            }
          });
      
          // Cleanup: Remove 'open' class from all sub-items not in the openDropdowns list
          Object.keys(subItemsRefs.current).forEach((id) => {
            if (!openDropdowns.includes(Number(id))) {
              subItemsRefs.current[id].classList.remove('open');
            }
          });
    },[openDropdowns]);
  return (
    <div className='Accordian-container'>
        {
            data.map((item, index) => (
                <div key={index}>
                <p className='Accordian-bar' onClick={(event) =>toggleDropdown(index,event)}><img className='Accordian-icon' src={buttonToRender(index)} alt="plus-2-math"/> {item.category}</p>
                {item.pages && (
                    <>{ 
                        <div className='Accordian-subItems'  ref={(el) => (subItemsRefs.current[index] = el)}>
                        {item.pages.map((page,index) => (
                            <Link className='Accordian-subBar' key={index} to={`/article/${page.articleUID}`}><svg className='Accordian-icon' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 50 50">
                            <path d="M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z M 15 22 L 15 24 L 35 24 L 35 22 Z M 15 28 L 15 30 L 31 30 L 31 28 Z M 15 34 L 15 36 L 35 36 L 35 34 Z"></path>
                            </svg> {page.title.length > 30 ? `${page.title.slice(0, 30)}...` : page.title}</Link>
                        ))}
                        </div>
                    }</>
                )}
                </div>
            ))
        }
    </div>
  )
}

export default Accordian